import { slideDown, slideUp } from "./helpers/plainSlide.js";
const header = document.querySelector('header.site-header');

// Scroll body to the form with class of '.gform_validation_error' and '.gform_confirmation_wrapper 
const gformError = document.querySelector('.gform_wrapper.gform_validation_error, .gform_confirmation_wrapper');
if (gformError) {
  // window.scrollTo(0, gformError.offsetTop);
  document.documentElement.scrollTo({
    left: 0,
    top: (gformError.offsetTop - header.offsetHeight) - header.offsetHeight,
    behavior: 'smooth'
  });
}

// GDPR Links
const gdprLinks = document.querySelectorAll('a[href="#gdpr"]');

// console.log(gdprLinks);
if (gdprLinks) {
  for (let i = 0; i < gdprLinks.length; i++) {
    const gdprLink = gdprLinks[i];
    const fieldItem = gdprLink.parentElement.parentElement.parentElement;
    const gdprDescription = fieldItem ? fieldItem.querySelector('.gfield_consent_description') : false;

    if (fieldItem.classList.contains('gfield') && gdprDescription) {
      gdprLink.addEventListener('click', function (e) {
        e.preventDefault();
        // If gdpr description is hidden with display none 
        if (gdprDescription.style.display == 'block') {
          slideUp(gdprDescription,300);
        } else {
          slideDown(gdprDescription, 300);
          document.documentElement.scrollTo({
            left: 0,
            top: (gdprDescription.offsetTop - header.offsetHeight) - header.offsetHeight,
            behavior: 'smooth'
          });
        }
      });
    }
  }
}
